/**
 * Fleet Management Module Constants
 */

/**
 * Volume Capacity Constants
 * Minimum capacity requirements for volume provisioning.
 */
export const MIN_VOLUME_CAPACITY = {
    VALUE: 20,
    UNIT: 'MiB'
};

/**
 * LUN Capacity Constants
 * Minimum capacity requirements for LUN provisioning.
 */
export const MIN_LUN_CAPACITY = {
    VALUE: 4,
    UNIT: 'KiB'
};

export const RESOURCE_TYPE = 'ON_PREM';
export const RESOURCE_CLASS = 'ON_PREM';

export const CAPACITY_WARNING_LIMIT = 80; // 80% warning limit for storage capacity
export const TOP_PERFORMANCE_SYSTEMS_COUNT = 5; // Number of top systems to display in storage performance chart

export const STORAGE_OBJECT_TABLE_ROW_ID_PREFIX = "storage-object-row";

export const ASA_R2 = 'ASA_R2';
export const AFX = 'AFX';

export const STORAGE_CLASS_MANAGE_DOC_URL = 'https://docs.netapp.com/us-en/console-local/task-storage-class-manage.html';
